import React, { CSSProperties, PropsWithChildren, useState } from "react";

interface FormContextProps {
  fields: Record<any, any>;
  setValue: (data: any) => void;
}
/**
 * -------------------------------
 * Form Context initialization
 * -------------------------------
 */
export const FormContext = React.createContext<FormContextProps>({
  fields: {},
  setValue: (data: any) => { },
});
const Provider = FormContext.Provider;
/**
 * -------------------------------
 * Form Provider state
 * -------------------------------
 */
export function FormProvider({ children }: PropsWithChildren) {
  const [fields, setFields] = useState<any>({});

  const setValue = (data: Record<any, any>) => {
    setFields((current: typeof data) => ({ ...current, ...data }));
  };
  return <Provider value={{ fields, setValue }}>{children}</Provider>;
}

/**
 * -------------------------------
 * Form HTML Element
 * -------------------------------
 */
function FormField({
  initialValues,
  id,
  className,
  style,
  onSubmit,
  children,
}: PropsWithChildren<{
  initialValues?: string;
  id?: string;
  className?: string;
  style?: CSSProperties;
  onSubmit: (data: any) => void;
}>) {
  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        let formElement: any = e.target;
        if (formElement) {
          let body = formElement.querySelectorAll("[name]");
          let bodyData: any[] = [];
          body.forEach((element: any) => {
            bodyData.push({ [element.name]: element.value });
          });
          onSubmit(bodyData);
        }
      }}
    >
      {children}
    </form>
  );
}

export default FormField;
